import React, { Fragment } from 'react'
import logo from '../../Assets/Images/logo.png'
import { Link } from 'react-router-dom'
import phoneIcon from '../../Assets/Images/phoneIcon.png'
import emailIcon from '../../Assets/Images/emailIcon.png'
import locationPin from '../../Assets/Images/location-pin.png'
import { FaFacebookF, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from "react-icons/fa";


const Footer = () => {
    return (
        <Fragment>
            <section className='bg-light py-5 footer'>
                <div className="container">
                    <div className="row  justify-content-between">
                        <div className="col-lg-4">
                            <Link to={"/"}>
                                <img src={logo} className='logo mb-3' alt="" />
                            </Link>

                            <p>
                                Rennwriters is a online bookstore website who sells all genres of books from around the world. Find your book here now
                            </p>
                        </div>

                        <div className="col-lg-3  mt-3">
                            <h4 className='footer-heading mb-3'>
                                Quick Links
                            </h4>
                            <ul>
                                <li>
                                    <Link to="/terms-and-condition">
                                        Terms & Conditions
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/privacy-policy">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="cookie-policy">
                                        Cookie Policy
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-4 mt-3">
                            <h4 className='footer-heading mb-3'>
                                Contact info
                            </h4>
                            <ul>
                                <li>
                                    <Link to="#" onClick={() => window.location.href = "tel:+012345678999"}>
                                        <img className='me-3' src={phoneIcon} alt="Phone" />
                                        +012 345 678 999
                                    </Link>
                                </li>
                                <li>
                                    <Link style={{ wordBreak: "break-all" }} to="#" onClick={() => window.location.href = "mailto:info@rennwrites.com"}>
                                        <img className='me-3' src={emailIcon} alt="Email" />
                                        info@rennwrites.com
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <img className='me-3' src={locationPin} alt="Location" />
                                        Office # 123, Lorem ipsum, Dummy address, CA 123456
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-12">
                            <h4 className='footer-heading mb-3'>
                                Follow Us
                            </h4>
                            <div className="row gx-2">
                                <div className="col-auto">
                                    <div className="footer-social">
                                        <FaFacebookF size={22} />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="footer-social">
                                        <FaYoutube size={22} />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="footer-social">
                                        <FaTwitter size={22} />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="footer-social">
                                        <FaLinkedin size={22} />
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="footer-social">
                                        <FaInstagram size={22} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </Fragment>
    )
}

export default Footer